import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import "react-datepicker/dist/react-datepicker.css";

// MUI imports
import { Button, CircularProgress, Grid } from "@mui/material";

// Project imports
import TextFieldTR from "./TextFieldTR";
import SelectTR from "./SelectTR";
import ButtonTR from "./ButtonTR";
import DatePickerWrapper from "./DatePickerWrapper";

import { CreatePCAContext } from "./helpers";

import {
  createPcaRecord,
  resetCreatePcaRecord,
  getAllRegisteredCmPca,
} from "../../Actions";

const formValidationSchema = Yup.object().shape({
  trainingCenterName: Yup.string().required("This is a required field"),
  skillid: Yup.string().required("This is a required field"),
  trainigCost: Yup.number()
    .integer()
    .required("This is a required field")
    .typeError("Please enter only numbers"),
});

const initial_state = {
  trainingCenterName: "",
  skillid: "",
  trainigCost: "",
};

const StepTwo = () => {
  const globalDispatch = useDispatch();
  const contextObject = useContext(CreatePCAContext);

  const pcaReducer = (state) => state.postCampActivityReducer;
  const { cmDetails, allActiveSkills, createPCASuccess, creatingPCARecord } =
    useSelector(pcaReducer);

  const [valDate, setValDate] = useState({
    performCheck: false,
    checkComplete: false,
    checkPassed: false,
    startDate: "",
    endDate: "",
  });

  const [formikValues, setFormikValues] = useState("");

  useEffect(() => {
    if (createPCASuccess && contextObject.activeStep === 1) {
      globalDispatch(resetCreatePcaRecord());
      globalDispatch(getAllRegisteredCmPca());
      contextObject.handleCloseMiddleWare();
    }
  }, [createPCASuccess]);

  useEffect(() => {
    if (valDate.checkPassed) {
      const requestBody = {
        cmName: cmDetails.cmName,
        ppa: cmDetails.ppa,
        cmStateCode: cmDetails.stateCode,
        trainingCenterName: formikValues?.trainingCenterName,
        skillId: formikValues?.skillid,
        trainingStartDate: valDate.startDate,
        trainingEndDate: valDate.endDate,
        trainigCost: formikValues?.trainigCost,
        lgaId: cmDetails.lgaId,
        gender: cmDetails.gender,
      };

      globalDispatch(createPcaRecord(requestBody));
    }
  }, [valDate]);

  function handleSubmit(values) {
    setFormikValues(values);
    setValDate({
      ...valDate,
      performCheck: true,
    });
  }

  return (
    <Formik
      initialValues={initial_state}
      validationSchema={formValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <Grid
          gap={2}
          container
          item
          xs
          sx={{
            display: "flex",
            flexDirection: "column",
            mt: "1rem",
          }}
        >
          <TextFieldTR
            label={"Name of vocational training center"}
            name={"trainingCenterName"}
          />

          <SelectTR
            label={"Skill to be acquired"}
            name={"skillid"}
            options={allActiveSkills}
          />

          <TextFieldTR label={"Cost of training"} name={"trainigCost"} currency={true} />

          <DatePickerWrapper valDate={valDate} setValDate={setValDate} />

          <Grid
            item
            xs
            container
            gap={3}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button
              disabled={creatingPCARecord}
              onClick={contextObject.handlePreviousStep}
            >
              Back
            </Button>
            <ButtonTR disabled={creatingPCARecord}>
              {creatingPCARecord ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                <>Save</>
              )}
            </ButtonTR>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

export default StepTwo;
